import { render, staticRenderFns } from "./CameraWindow.vue?vue&type=template&id=2132d6e7&scoped=true"
import script from "./CameraWindow.vue?vue&type=script&lang=js"
export * from "./CameraWindow.vue?vue&type=script&lang=js"
import style0 from "./CameraWindow.vue?vue&type=style&index=0&id=2132d6e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132d6e7",
  null
  
)

export default component.exports